module.exports = __webpack_public_path__ + "img/nav.f5e06651.png";